export default __webpack_public_path__ + "static/media/hero_4.f7311eaa.png";